import { useCallback, useState } from 'react';
import type { QualityRange } from './useQualityDateRange';

const isComparisonRange = (range: QualityRange): boolean => range !== 'all' && range !== 'latest';

type LazyComparisonDateRange = {
  comparisonActivated: boolean;
  range: QualityRange;
  selectedEndDay: string | null;
  selectedStartDay: string | null;
  activateComparisonForRange: (range: QualityRange) => void;
  handleEndDayChange: (day: string | null) => void;
  handleStartDayChange: (day: string | null) => void;
};

export const useLazyComparisonDateRange = (initialRange: QualityRange): LazyComparisonDateRange => {
  const [range, setRange] = useState<QualityRange>(initialRange);
  const [comparisonActivated, setComparisonActivated] = useState(false);
  const [selectedStartDay, setSelectedStartDay] = useState<string | null>(null);
  const [selectedEndDay, setSelectedEndDay] = useState<string | null>(null);

  const activateComparisonForRange = useCallback((next: QualityRange) => {
    setRange(next);
    setComparisonActivated(isComparisonRange(next));
    setSelectedStartDay(null);
    setSelectedEndDay(null);
  }, []);

  const handleStartDayChange = useCallback((next: string | null) => {
    setComparisonActivated(next !== null);
    setSelectedStartDay(next);
  }, []);

  const handleEndDayChange = useCallback((next: string | null) => {
    setComparisonActivated(next !== null);
    setSelectedEndDay(next);
  }, []);

  return {
    comparisonActivated,
    range,
    selectedEndDay,
    selectedStartDay,
    activateComparisonForRange,
    handleEndDayChange,
    handleStartDayChange,
  };
};
